// extracted by mini-css-extract-plugin
module.exports = {"flipFlop":"flipflop_flipFlop__xHWpN","image":"flipflop_image__Lo3iM","caption":"flipflop_caption__FcdP7","body":"flipflop_body__Ftlir","flipped":"flipflop_flipped__9x6WZ"};